import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { ContactUsPanel } from '@juvare/contact-management/ui/features/contact-us';
import { Button, DialogActions, DialogContent } from '@mui/material';
import { TFunction } from 'i18next';
import React from 'react';

export function showContactUsModal(t: TFunction<'rms'>) {
    showCustomDialog({
        maxWidth: 'md',
        content: (close) => (
            <>
                <DialogContent>
                    <ContactUsPanel appName={window.appName} isAnonymous={false} onAfterSubmit={() => close()} />
                </DialogContent>
                <DialogActions>
                    <Button color='primary' onClick={() => close()}>
                        {t('common.cancel')}
                    </Button>
                </DialogActions>
            </>
        ),
        onEscapeKeyDown: (close) => close(),
    });
}
